import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class PinTypeDbTableDefinition extends DbTableDefinition {
    tableName = 'pintypes';
    tableStructure = `(id BIGINT(20) PRIMARY KEY NOT NULL,
       databag LONGTEXT,
       name TEXT NOT NULL,
       description TEXT NOT NULL,
       icon VARCHAR(255) NOT NULL
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}